import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
// import { toggle } from "employees/actions";
// import { addGrowlError as error, addGrowlSuccess as success } from "messages/actions";

import EmployeesList from 'employees/components/list';

class EmployeesRowContainer extends Component {
  // handleToggle = id =>
  //   this.props
  //     .toggle(id, this.props.company.id, this.props.subcompany.id)
  //     .then(({ value }) => this.props.success(value.message))
  //     .catch(err => this.props.error(err.message));

  render = () => (
    <EmployeesList.Row
      /////////////
      handleToggle={this.props.handleToggle}
      /////////////
      company={this.props.company}
      subcompany={this.props.subcompany}
      employee={this.props.employee}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

// const mapDispatchToProps = { toggle, error, success };

export default connect(mapStateToProps, null)(EmployeesRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/containers/EmployeesRowContainer.js